export default "__VITE_ASSET__6039c852__"